import script from "./ChatSidebarUser.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatSidebarUser.vue?vue&type=script&setup=true&lang=js"

import "./ChatSidebarUser.vue?vue&type=style&index=0&id=360cb9ef&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-360cb9ef"]])

export default __exports__